import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/rehype-katex/node_modules/katex/dist/katex.min.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2024/multi-cloud/amplify01.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2024/multi-cloud/amplify02.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2024/multi-cloud/cloudrun01.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2024/multi-cloud/cloudrun02.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2024/multi-cloud/cloudrun03.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2024/multi-cloud/cloudrun04.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2024/multi-cloud/cloudrun05.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2024/multi-cloud/cloudrun12.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2024/multi-cloud/cloudwatch01.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2024/multi-cloud/footer01.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2024/multi-cloud/lambda01.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2024/multi-cloud/lambda02.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2024/multi-cloud/route5301.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2024/multi-cloud/route5302.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(blog)/2024/multi-cloud/route5311.webp");
